import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useDispatch,useSelector  } from 'react-redux';
import { updateState,selectC5State  } from '../../../features/counter/counterSlice';
import { extractGuidelineName } from '../../../utils/getGuidelinefromUrlSearchResults';
const DropdownItem = ({
  item,
  index,
  handleSelect,
  isDrugIndex,
  isSuggestion = false,
  highlightText,
  keyword,
  resultStyle,
}) => {
  const dispatch = useDispatch();
  const text = isSuggestion ? item.suggestion : item.searchText;
  const typeLabel = isSuggestion ? item.type : null;
   const currentC5State = useSelector(selectC5State);
  const handleAction = () => {
    if (item?.url?.includes("/viewTopic?etgAccess=true&guidelinePage=")) {
      const { guidelineName} = extractGuidelineName(item.url);

      console.log("guidelinePage", guidelineName);
      dispatch(
        updateState({
          C5State: {
            ...currentC5State,
            databaseID: guidelineName,
            titleID: item?.title,
            eventType: "Searches Regular",
          },
        })
      );
    }
    console.log("item", item);


    handleSelect(item);
  };

  return (
    <div
      role='link'
      key={index}
      className={
        resultStyle[
        isSuggestion ? 'dropdown-item' : 'dropdown-recent-saved-item'
        ]
      }
      onClick={handleAction}
      onKeyDown={(e) => e.key === "Enter" && handleAction()}

      tabIndex={0}
      onMouseDown={(e) => e.preventDefault()}
      data-testid='search-suggestions'
    >
      {typeLabel && <div className='light text-xs capitalize'>{typeLabel}</div>}
      {isDrugIndex ? (
        highlightText(text, keyword)
      ) : (
        <span
          className={classNames('medium text-sm', resultStyle.description)}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      )}
    </div>
  );
};

DropdownItem.propTypes = {
  item: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  handleSelect: PropTypes.func.isRequired,
  isDrugIndex: PropTypes.bool,
  isSuggestion: PropTypes.bool,
  highlightText: PropTypes.func.isRequired,
  keyword: PropTypes.string,
  resultStyle: PropTypes.object.isRequired,
};

export default DropdownItem;
